import React from 'react';
import { AvatarSize } from '@askporter/component-library/Avatar';
import { RevampedIcon, RevampedIconSize } from '@askporter/component-library/RevampedIcon';
import { SxProps, Theme } from '@mui/material/styles';
import {
  AssetSearchResultExternal,
  AssetSummaryAncestralExternal,
  SearchAssetResultExternal,
} from '@askporter/client-grieg-lyric';
import { useSearchAutocomplete } from '../../hooks/useSearchAutocomplete';
import RevampedSearchAutocomplete, { RevampedSearchAutocompleteProps } from '../RevampedSearchAutocomplete';
import AssetOptionAvatar from './components/AssetOptionAvatar';
export type AssetSummary = (AssetSearchResultExternal | AssetSummaryAncestralExternal) & {
  assetTypeUid?: string;
};
type PermittedRevampedSearchAutocompleteProps = Pick<
  RevampedSearchAutocompleteProps<AssetSummary>,
  'sx' | 't' | 'label' | 'placeholder' | 'disabled' | 'error' | 'clearable' | 'readOnly' | 'readOnlyText'
>;
type AssetAutocompleteProps = PermittedRevampedSearchAutocompleteProps & {
  onChange: (asset: AssetSummary | null) => void;
  value: AssetSummary | null;
  textFieldSx?: SxProps<Theme>;
  onInputChange?: (event: React.SyntheticEvent, newInputValue: string) => void;
};
/** Renders an AssetAutocomplete component */
const AssetAutocomplete: React.FC<React.PropsWithChildren<AssetAutocompleteProps>> = (
  props: AssetAutocompleteProps,
) => {
  const autocompleteProps = useSearchAutocomplete<AssetSummary, SearchAssetResultExternal>({
    path: 'assets/search',
  });
  return (
    <RevampedSearchAutocomplete<AssetSummary>
      {...props}
      {...autocompleteProps}
      idPrefix={'asset'}
      getOptionLabel={(asset: AssetSummary) => asset?.title || asset?.assetRef || ''}
      startAdornment={
        props.value ? (
          <AssetOptionAvatar asset={props.value} avatarSize={AvatarSize.SM} />
        ) : (
          <RevampedIcon fullPath="/media/icons/design-system/asset/24px.svg" iconSize={RevampedIconSize.MD} />
        )
      }
    />
  );
};
export default AssetAutocomplete;
